import React, { useState, useEffect, useContext, createContext, useMemo } from 'react';
import toast, { Toaster } from 'react-hot-toast';

import LeftMenu from '../menu/menu';
import { DataContext } from './getData';

import SupplierForm from '../purchaseTab/supplier/supplierForm';
import CustomerForm from '../salesTab/customer/customerForm';
import SimpleForm from '../inventoryTab/product/simple/simpleForm';
import ExpenseAccountForm from '../expensesTab/expenseAccount/expenseAccountForm';
import ExpenseSupplierForm from '../expensesTab/expenseSupplier/expenseSupplierForm';
import AccountForm from '../accountTab/auxAccount/accountForm';
import EmployeeForm from '../hrTab/employee/employeeForm';
import { Empty } from 'antd';


export const DynamicModalContext = createContext();





const DynamicModals = (props) => {


  const { api, userData, settingData, selectedCompany, selectedYear } = useContext(DataContext);

  const createdBy = parseInt(userData.id);
  const companyId = selectedCompany?.id;
  const yearId = selectedYear?.id;

  const userRole = userData?.role;
  const branchId = userRole?.branchId;
  const warehouseId = userRole?.warehouseId;


  //Modals
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [showSupplierModal, setShowSupplierModal] = useState(false);

  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [addedCustomer, setAddedCustomer] = useState(false);

  const [showProductModal, setShowProductModal] = useState(false);
  const [productAddType, setProductAddType] = useState('simple');
  const [productIdRow, setProductIdRow] = useState([]);

  const [showExpenseAccountModal, setShowExpenseAccountModal] = useState(false);
  const [showExpenseSupplierModal, setShowExpenseSupplierModal] = useState(false);


  const openAddEmployeeModal = (e) => {
    setShowEmployeeModal(!showEmployeeModal);
  }


  const openAddExpenseAccountModal = (e) => {
    setShowExpenseAccountModal(!showExpenseAccountModal);
  }

  const openAddExpenseSupplierModal = (e) => {
    setShowExpenseSupplierModal(!showExpenseSupplierModal);
  }


  const openAddSupplierModal = (e) => {
    setShowSupplierModal(!showSupplierModal);
  }

  const openAddCustomerModal = (e) => {
    setShowCustomerModal(!showCustomerModal);
  }

  const openAddAccountModal = (e) => {
    setShowAccountModal(!showAccountModal);
  }

  const openAddProductModal = (type, idRow) => {
    setProductAddType(type);
    setProductIdRow(idRow);
    setShowProductModal(!showProductModal);
  }


  const dataContextValue = useMemo(() => ({

    openAddSupplierModal,
    openAddAccountModal,
    openAddEmployeeModal,

    openAddExpenseSupplierModal,
    openAddExpenseAccountModal,

    openAddProductModal,

    openAddCustomerModal,
    setAddedCustomer,
    addedCustomer,


  }));



  return (

    <DynamicModalContext.Provider value={dataContextValue}>

      <LeftMenu />

      {showEmployeeModal &&
        <EmployeeForm
          showModal={showEmployeeModal}
          toggleModal={openAddEmployeeModal}
          refAddedData={true}
        />
      }

      {showExpenseAccountModal &&
        <ExpenseAccountForm
          showModal={showExpenseAccountModal}
          toggleModal={openAddExpenseAccountModal}
          refAddedData={true}
        />
      }


      {showExpenseSupplierModal &&
        <ExpenseSupplierForm
          showModal={showExpenseSupplierModal}
          toggleModal={openAddExpenseSupplierModal}
          refAddedData={true}
        />
      }


      {showSupplierModal &&
        <SupplierForm
          showModal={showSupplierModal}
          toggleModal={openAddSupplierModal}
          refAddedData={true}
        />
      }

      {showCustomerModal &&
        <CustomerForm
          showModal={showCustomerModal}
          toggleModal={openAddCustomerModal}
          refAddedData={true}
          setAddedCustomer={setAddedCustomer}
        />
      }


      {showProductModal &&
        <SimpleForm
          showModal={showProductModal}
          toggleModal={() => openAddProductModal()}
          type={productAddType}
          refAddedData={true}
          idRow={productIdRow}
        />
      }

      {showAccountModal &&
        <AccountForm
          showModal={showAccountModal}
          toggleModal={openAddAccountModal}
          refAddedData={true}
        />
      }


    </DynamicModalContext.Provider>


  );
}
export default DynamicModals;
